/** 营销活动状态：0草稿 / 1已发布 / 2已下线 / 3已结束 */
export const ACTIVITY_STATUS = {
  DRAFT: 0,
  PUBLISHED: 1,
  OFFLINE: 2,
  ENDED: 3
} as const

export const ACTIVITY_STATUS_OPTIONS = [
  { label: '草稿', value: 0 },
  { label: '已发布', value: 1 },
  { label: '已下线', value: 2 },
  { label: '已结束', value: 3 }
]

/** 奖品类型（与后端对齐） */
export const PRIZE_TYPE_OPTIONS = [
  { label: '实物', value: 1 },
  { label: '优惠券', value: 2 },
  { label: '积分', value: 3 },
  { label: '红包/现金', value: 4 },
  { label: '兑换码', value: 5 },
  { label: '谢谢参与', value: 6 }
]

export const GRANT_STATUS_OPTIONS = [
  { label: '待发放', value: 0 },
  { label: '已发放', value: 1 },
  { label: '发放失败', value: 2 }
]

export const PLAY_RESULT_OPTIONS = [
  { label: '未中奖', value: 0 },
  { label: '中奖', value: 1 }
]

export const getActivityStatusLabel = (status?: number) =>
  ACTIVITY_STATUS_OPTIONS.find((i) => i.value === status)?.label ?? '-'

export const getPrizeTypeLabel = (type?: number) =>
  PRIZE_TYPE_OPTIONS.find((i) => i.value === type)?.label ?? '-'
